module.exports = __webpack_public_path__ + "img/idt-icon.6108d7ae.svg";